export default "__VITE_ASSET__CZoVrntK__"